<div class="page-body" [class.showskyline]="showBackground" [attr.dir]="isrtl ? 'rtl' : 'ltr'" [class.direction-rtl]="isrtl" [class.direction-ltr]="!isrtl">
    <ngb-alert *ngIf="showAlert" [type]="alertType" (closed)="showAlert=false">{{ alertMessage }}</ngb-alert>
    <app-loader></app-loader>
    <router-outlet></router-outlet>
</div> 